import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const initAnimations = () => {
  const settings = {
    duration: 0.5,
  };

  const initScrollTrigger = (tl, el, start = "top bottom-=20%") => {
    ScrollTrigger.create({
      animation: tl,
      trigger: el,
      start: () => start,
    });
  };

  const getDefaultAnim = (from, to) => {
    return [{
        opacity: 0,
        y: "100px",
        ...from,
      },
      {
        opacity: 1,
        y: 0,
        duration: settings.duration,
        stagger: 0.2,
        ease: "power3.out",
        ...to,
      },
    ];
  };

  const riseUp = document.querySelectorAll("[data-rise-up]");
  riseUp.forEach((el) => {
    let delay = window.innerWidth < 1280 && el.getAttribute('data-mobile-delay') ? el.getAttribute('data-mobile-delay') : el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=20%';
    const tl = gsap.fromTo(el, ...getDefaultAnim({}, {
      delay: delay,
      duration: settings.duration,
    }));
    if (el.closest('[data-rise-up-group]')) {
      initScrollTrigger(tl, el.closest('[data-rise-up-group]'));
    } else {
      initScrollTrigger(tl, el, start);
    }
  });

  const animRight = document.querySelectorAll('[data-anim-right]');
  animRight.forEach((el) => {
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=30%';
    const tl = gsap.fromTo(el, {
      x: '100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "power1.out",
      delay: delay,
    });
    initScrollTrigger(tl, el, start);
  });

  const animOpacity = document.querySelectorAll('[data-anim-opacity]');
  animOpacity.forEach((el) => {
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=30%';
    const tl = gsap.fromTo(el, {
      opacity: 0,
    }, {
      opacity: 1,
      duration: settings.duration,
      ease: "power1.out",
      delay: delay,
    });
    initScrollTrigger(tl, el, start);
  });

  const animLeft = document.querySelectorAll('[data-anim-left]');
  animLeft.forEach((el) => {
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=30%';
    const tl = gsap.fromTo(el, {
      x: '-100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "power1.out",
      delay: delay,
    });
    initScrollTrigger(tl, el, start);
  });

  const listRiseUpAnim = document.querySelectorAll('[data-rise-list]');
  listRiseUpAnim.forEach((el) => {
    const items = el.querySelectorAll('[data-rise-item]');
    let start = el.getAttribute('data-start') || 'top bottom-=20%';
    let delay = window.innerWidth < 1280 && el.getAttribute('data-mobile-delay') ? el.getAttribute('data-mobile-delay') : el.getAttribute('data-delay') || 0;
    const tl = gsap.fromTo(items, {
      y: '100',
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "ease",
      delay: delay,
      stagger: 0.2,
    });

    initScrollTrigger(tl, el, start);
  });

  const listLeftAnim = document.querySelectorAll('[data-left-list]');
  listLeftAnim.forEach((el) => {
    const items = el.querySelectorAll('[data-left-item]');
    let delay = el.getAttribute('data-delay') || 0;
    let start = el.getAttribute('data-start') || 'top bottom-=-20%';
    const tl = gsap.fromTo(items, {
      x: '-100px',
      opacity: 0,
    }, {
      x: 0,
      opacity: 1,
      duration: settings.duration,
      ease: "ease",
      delay: delay,
      stagger: 0.2,
    });

    initScrollTrigger(tl, el, start);
  });

  const paralaxAnim = document.querySelectorAll('[data-paralax-wrap]');
  paralaxAnim.forEach((el) => {
    const items = el.querySelectorAll('[data-paralax]');
    items.length > 0 && items.forEach(item => {
      gsap.to(item, {
        yPercent: 32,
        ease: "none",
        scrollTrigger: {
          trigger: el,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      });
    });

    const patterns = el.querySelectorAll('[data-paralax-line]');
    patterns.length > 0 && patterns.forEach(item => {
      gsap.to(item, {
        yPercent: 15,
        ease: "none",
        scrollTrigger: {
          trigger: document.querySelector('body'),
          start: "top top",
          end: "bottom bottom",
          scrub: true,
        },
      });
    });
  });
}
